var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, queryAssignedNodes, state } from 'lit/decorators.js';
import '../avatar/sds-avatar.lit';
import styles from './sds-avatar-group.lit.scss';
import { SdsAvatar } from './sds-avatar.lit';
import { sdsCustomElement } from '../utilities/custom-components';
const availableSizes = ['xl', 'lg', 'md', 'sm'];
/**
 *  Component is used to representing avatars group.
 *
 *  @slot - Content which is rendered avatars group.
 *
 */
let SdsAvatarGroup = (() => {
    var _SdsAvatarGroup__slots_accessor_storage, _SdsAvatarGroup__count_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-avatar-group')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let __slots_decorators;
    let __slots_initializers = [];
    let __slots_extraInitializers = [];
    let __count_decorators;
    let __count_initializers = [];
    let __count_extraInitializers = [];
    let _set_size_decorators;
    let _set_visibleCount_decorators;
    var SdsAvatarGroup = _classThis = class extends _classSuper {
        get _slots() { return __classPrivateFieldGet(this, _SdsAvatarGroup__slots_accessor_storage, "f"); }
        set _slots(value) { __classPrivateFieldSet(this, _SdsAvatarGroup__slots_accessor_storage, value, "f"); }
        get _count() { return __classPrivateFieldGet(this, _SdsAvatarGroup__count_accessor_storage, "f"); }
        set _count(value) { __classPrivateFieldSet(this, _SdsAvatarGroup__count_accessor_storage, value, "f"); }
        get size() {
            return this._size;
        }
        set size(value) {
            const oldValue = this._size;
            this._size = value;
            this.requestUpdate('size', oldValue);
        }
        get visibleCount() {
            return this._visibleCount;
        }
        set visibleCount(newVal) {
            if (newVal < 1 || newVal > 5) {
                console.warn('Min can be any value between 1 and 5');
            }
            else {
                const oldVal = this._visibleCount;
                this._visibleCount = newVal;
                this.requestUpdate('visible-count', oldVal);
            }
        }
        render() {
            return html `
            <div class="sds-avatar-group">
                <slot></slot>
                ${this.getAvatarCountTemplate()}
            </div>
        `;
        }
        firstUpdated() {
            let count = 0;
            let lastElement;
            const minShow = this.visibleCount === this._max ? this.visibleCount - 1 : this.visibleCount;
            this._slots.forEach(value => {
                if (value instanceof SdsAvatar) {
                    if (count >= minShow) {
                        value.style.display = 'none';
                        lastElement = value;
                    }
                    ++count;
                }
            });
            this._count = count - minShow;
            if (lastElement && this._count === 1 && this.visibleCount === this._max) {
                lastElement.style.display = '';
            }
        }
        getAvatarCountTemplate() {
            if (this._count > 1 || (this.visibleCount === this._max - 1 && this._count === 1)) {
                return html `
                <sds-avatar
                    count="${this._count}"
                    size="${this.size}"
                    ?disabled="false"
                ></sds-avatar>
            `;
            }
            else {
                return html ``;
            }
        }
        constructor() {
            super(...arguments);
            /**
             * Avatar size
             * @attr
             */
            this._size = (__runInitializers(this, _instanceExtraInitializers), 'md');
            this._visibleCount = 6;
            this._max = 6;
            _SdsAvatarGroup__slots_accessor_storage.set(this, __runInitializers(this, __slots_initializers, void 0));
            _SdsAvatarGroup__count_accessor_storage.set(this, (__runInitializers(this, __slots_extraInitializers), __runInitializers(this, __count_initializers, 0)));
            __runInitializers(this, __count_extraInitializers);
        }
    };
    _SdsAvatarGroup__slots_accessor_storage = new WeakMap();
    _SdsAvatarGroup__count_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsAvatarGroup");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __slots_decorators = [queryAssignedNodes()];
        __count_decorators = [state()];
        _set_size_decorators = [property({
                type: String,
                hasChanged: (newVal) => {
                    if (!availableSizes.includes(newVal)) {
                        console.error(`Unexpected Size ${newVal}`);
                        return false;
                    }
                    else {
                        return true;
                    }
                },
            })];
        _set_visibleCount_decorators = [property({ type: Number, attribute: 'visible-count' })];
        __esDecorate(_classThis, null, __slots_decorators, { kind: "accessor", name: "_slots", static: false, private: false, access: { has: obj => "_slots" in obj, get: obj => obj._slots, set: (obj, value) => { obj._slots = value; } }, metadata: _metadata }, __slots_initializers, __slots_extraInitializers);
        __esDecorate(_classThis, null, __count_decorators, { kind: "accessor", name: "_count", static: false, private: false, access: { has: obj => "_count" in obj, get: obj => obj._count, set: (obj, value) => { obj._count = value; } }, metadata: _metadata }, __count_initializers, __count_extraInitializers);
        __esDecorate(_classThis, null, _set_size_decorators, { kind: "setter", name: "size", static: false, private: false, access: { has: obj => "size" in obj, set: (obj, value) => { obj.size = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _set_visibleCount_decorators, { kind: "setter", name: "visibleCount", static: false, private: false, access: { has: obj => "visibleCount" in obj, set: (obj, value) => { obj.visibleCount = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsAvatarGroup = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsAvatarGroup = _classThis;
})();
export { SdsAvatarGroup };
